import { Sales } from "@/pages/sales";

export const routeSales = "/sales";

export const salesRoutes = [
	{
		path: routeSales,
		element: <Sales />,
		permission: "ui.navbar.sales",
	},
];
